import axios from "../axios/axios";
import { appSetLoading } from "../store/actions/appAction";
import { errorDispatcher } from "../helpers";
import fileDownload from "js-file-download";
import { setBusiness } from "../store/actions/businessAction";

export const apiDeleteOffline = (token, business) => (dispatch, getState) => {
  dispatch(appSetLoading());
  axios
    .get(`businesses/offline/deactivate`, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((response) => {
      business = { ...business, business: { ...business.business, offlineConfig: null } };
      dispatch(setBusiness(business));
      dispatch(appSetLoading(false));
    })
    .catch((error) => {
      errorDispatcher(error, dispatch);
    });
};

export const apiDownloadConfig = (token) => (dispatch, getState) => {
  dispatch(appSetLoading());
  axios
    .get("businesses/offline/config", {
      headers: { Authorization: `Bearer ${token}` },
      responseType: "blob",
    })
    .then((response) => {
      dispatch(appSetLoading(false));
      fileDownload(response.data, "License.json");
    })
    .catch((error) => {
      errorDispatcher(error, dispatch);
    });
};
